export default "__VITE_ASSET__DjnKrOUr__"